// "Combo Hamburguesa – Refresco": así cocina/barra saben que surten parte de un combo.
export function comboLineName(comboName, compName) {
  const c = (comboName || "").trim();
  return `${/^combo\b/i.test(c) ? c : `Combo ${c}`} – ${compName}`;
}

// Reemplaza cada combo por sus productos para imprimir comandas por área/estación.
export function expandCombos(items) {
  const out = [];
  (items || []).forEach((i) => {
    if (i.separator || !(i.combo_items || []).length) { out.push(i); return; }
    i.combo_items.forEach((c) => {
      out.push({
        ...i, product_id: c.product_id, name: comboLineName(i.name, c.name), quantity: (c.quantity || 1) * (i.quantity || 1),
        area_id: c.area_id || i.area_id, station: c.station || i.station,
        requires_comanda: c.requires_comanda !== false, combo_items: [],
      });
    });
  });
  return out;
}
